module.exports = __webpack_public_path__ + "img/glass_grey.a08d331f.svg";